import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { StatusDescriptor } from '../status.model';

/**
 * A small coloured dot for dense lists (tree rows, card headers, table cells).
 * Always carries an accessible label; `pulse` is for live/online emphasis.
 */
@Component({
    selector: 'app-health-dot',
    standalone: true,
    template: ``,
    styleUrl: './health-dot.component.scss',
    host: {
        class: 'app-health-dot',
        role: 'img',
        '[attr.data-status]': 'status().key',
        '[class.app-health-dot--pulse]': 'pulse()',
        '[attr.aria-label]': 'ariaLabel()',
        '[title]': 'ariaLabel()'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HealthDotComponent {
    status = input.required<StatusDescriptor>();
    pulse = input(false);
    /** Optional prefix, e.g. the entity name: "Boardroom: Offline". */
    label = input<string | null>(null);

    ariaLabel = computed(() => {
        const l = this.label();
        return l ? `${l}: ${this.status().label}` : this.status().label;
    });
}
